import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { PrivateRoute } from "utility/routes";
import Users from "views/users";
import Rides from "views/rides";
import Ride from "views/ride";
import Groups from "views/groups";
import FourOhFour from "views/fourohfour";
import WhatsAppMessagesTable from "views/whatsapp";
import Carousel from "views/carousel";

function Container() {
    return (
        <div className="wrapper">
            <Routes>
                <Route path="/" element={<Navigate to="/users" replace />} />
                <Route path="/users" element={<PrivateRoute element={<Users />} />} />
                <Route path="/rides" element={<PrivateRoute element={<Rides />} />} />
                <Route path="/ride/:rideId" element={<PrivateRoute element={<Ride />} />} />
                <Route path="/groups" element={<PrivateRoute element={<Groups />} />} />
                <Route path="/whatsapp" element={<PrivateRoute element={<WhatsAppMessagesTable />} />} />
                <Route path="/carousel" element={<PrivateRoute element={<Carousel />} />} />
                <Route path="*" element={<PrivateRoute element={<FourOhFour />} />} />
            </Routes>
        </div>
    );
}

export default Container;
